import * as React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '@mui/material/Tooltip';

import ORDER_STATUS from '../../../../constants/orderStatus';
import toRusError from '../../../../utils/toRusError';

import MultilineTextarea from '../../../../../../../shared/ui/MultilineTextArea';
import AddressWrapper from './styles/AddressWrapper';
import Mark from './styles/Mark';
import AddressText from './styles/AddressText';
import WarningIcon from './styles/WarningIcon';

export default function AddressCell({ row, pointIndex, coords, onChange, addressText }) {
  const [isInput, setIsInput] = React.useState(false);
  const [changedAddressText, setChangedAddressText] = React.useState(addressText);
  const clickToInput = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
    setIsInput(true);
  };
  const changeHandler = (address) => {
    setChangedAddressText(address);
    onChange(address);
  };
  return (
    <AddressWrapper>
      <Mark color={row.color}>{pointIndex}</Mark>
      {isInput ? (
        <MultilineTextarea
          data={changedAddressText}
          altData={coords}
          onChange={changeHandler}
          onBlurHandler={() => setIsInput(false)}
        />
      ) : (
        <AddressText onClick={clickToInput}>{changedAddressText || coords}</AddressText>
      )}
      {!coords && (
        <Tooltip arrow placement="top" title={toRusError(ORDER_STATUS.INVALID_ADDRESS)}>
          <WarningIcon />
        </Tooltip>
      )}
    </AddressWrapper>
  );
}
AddressCell.propTypes = {
  row: PropTypes.shape().isRequired,
  addressText: PropTypes.string,
  pointIndex: PropTypes.number.isRequired,
  coords: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
AddressCell.defaultProps = {
  addressText: '',
};
